module.exports = __webpack_public_path__ + "assets/img/kuzstu-logo2.39082482.png";